<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h4 class="font-weight-light">
              <span class="font-weight-bold">ลูกค้าทั้งหมด</span>
            </h4>
          </div>
          <div class="col-sm-6 d-none d-md-block"></div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="container-fluid">
        <Card>
          <div slot="body">
            <ShippersTable />
          </div>
        </Card>
      </div>
    </section>
  </div>
</template>

<script>
import ShippersTable from "@/components/derived/ShippersTable";
import Card from "@/components/core/Card";
import { i18n } from "@/i18n";

export default {
  name: "Shippers",
  components: { ShippersTable, Card },
  data() {
    return {
      shipperRows: null,
      shipperCounts: null,
    };
  },

  created() {
    // this.fetchShippers();
  },

  methods: {
    handleSearch(searchData) {
      this.shipperRows = null;
      this.$store.dispatch("shippers/searchShippers", {
        ...searchData,
        callback: (status, data) => {
          this.shipperRows = data.results.map((d) => {
            return {
              id: d.id,
              details: {
                trackingNo: d.trackingNo,
                status: d.status,
                remarks: d.remarks,
                shippingMethod: d.shippingMethod,
                shipperCode: d.shipperCode,
                customer: {
                  name: d.customerName,
                  address: {
                    address: d.address,
                    zipcode: d.zipcode,
                    socialLink: d.socialLink,
                  },
                  phoneNo: d.phoneNo,
                },
              },
              tn: d.tn,
              createdAt: d.createdAt,
            };
          });
        },
      });
    },

    handleDelete() {
      this.fetchShippers();
    },

    fetchShippers() {
      this.shipperRows = null;
      this.$store.dispatch("shippers/fetchShippers", {
        callback: (status, data) => {
          console.log(data)
          if (status) {
            this.shipperRows = data.shippers;
          }
        },
      });
    },
  },
};
</script>

<style></style>
